<template>
  <v-container>
    <v-container class="pt-0">

      <!-- Buttons panel for expanded size -->
      <v-col class="text-right hidden-sm-and-down pt-0 pr-0">
        <v-btn
          class="mr-4"
          color="grey darken-1"
          :loading="reloadLoading"
          v-if="savingEnable"
          @click="reload"
          outlined
          tile
        >
          <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
        </v-btn>
        <v-btn
          color="primaryLigth"
          :loading="saveLoading"
          :disabled="saveDisabled"
          v-if="savingEnable"
          @click="save"
          outlined
          tile
        >
          <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
        </v-btn>
      </v-col>

      <v-subheader class="pl-0">{{ $t("WADO") }}</v-subheader>

      <v-row>
        <v-col cols="12" md="12">
          <v-combobox
            v-model="sopCuidsFilter"
            :loading="firstLoading"
            :class="{'disable-events': !savingEnable}"
            @input="saveDisabled=false;"
            :items="sopCuidsFilterItems"
            :label="$t('Filtered SOP Classes')"
            clearable
            hide-selected
            multiple
          ></v-combobox>
        </v-col>
      </v-row>

      <v-subheader class="pl-0">{{ $t("DICOM Viewers") }}</v-subheader>

      <v-row>
        <v-col cols="6" md="6">
          <v-bottom-navigation height="100px">
            <v-btn @click="radiant=!radiant; saveDisabled=false;">
              <img src="resources/images/radiant.svg" height="75px" v-if="radiant" />
              <img src="resources/images/radiant.svg" height="75px" class="disabled" v-else />
            </v-btn>
            <v-btn @click="horos=!horos; saveDisabled=false;">
              <img src="resources/images/horos.png" height="75px" v-if="horos" />
              <img src="resources/images/horos.png" height="75px" class="disabled" v-else />
            </v-btn>
            <v-btn @click="weasis=!weasis; saveDisabled=false;">
              <img src="resources/images/weasis.svg" height="75px" v-if="weasis" />
              <img src="resources/images/weasis.svg" height="75px" class="disabled" v-else />
            </v-btn>
            <v-btn @click="orthanc=!orthanc; saveDisabled=false;">
              <img src="resources/images/orthanc.png" height="75px" v-if="orthanc" />
              <img src="resources/images/orthanc.png" height="75px" class="disabled" v-else />
            </v-btn>
            <v-btn @click="ohif=!ohif; saveDisabled=false;">
              <img src="resources/images/ohif.svg" height="75px" v-if="ohif" />
              <img src="resources/images/ohif.svg" height="75px" class="disabled" v-else />
            </v-btn>
          </v-bottom-navigation>
        </v-col>

        <v-col cols="12" md="12" class="pt-6">
          <v-text-field
            v-model="orthancUrl"
            :class="{ 'disable-events': !savingEnable }"
            @input="saveDisabled = false;"
            :label="$t('Orthanc URL')"
            dense
          ></v-text-field>
        </v-col>
      </v-row>

    </v-container>
    <v-container class="text-right hidden-md-and-up pl-6 pr-6 mb-6">
      <v-btn
        class="mr-4"
        color="grey darken-1"
        :loading="reloadLoading"
        @click="reload"
        outlined
        tile
      >
        <v-icon left>mdi-autorenew</v-icon>{{ $t("reload") }}
      </v-btn>
      <v-btn
        color="primaryLigth"
        :loading="saveLoading"
        :disabled="saveDisabled"
        v-if="savingEnable"
        @click="save"
        outlined
        tile
      >
        <v-icon left>mdi-content-save-outline</v-icon>{{ $t("save") }}
      </v-btn>
      
    </v-container>
  </v-container>
</template>

<script>
import axios from "axios";
import i18n from "../../i18n";
import Sops from "../../lists/sops";
import EventBus from "../../event-bus";

export default {
  name: "DicomWebForm",
  data: () => ({
    firstLoading: true,
    saveLoading: false,
    saveDisabled: true,
    reloadLoading: false,
    updateOnError: true,
    sopCuidsFilter: [],
    sopCuidsFilterItems: Sops.items,
    savingEnable: false,
    radiant: true,
    weasis: true,
    orthanc: true,
    ohif: true,
    orthancUrl: null,
    horos: true,
  }),
  mounted() {
    // Permissions
    let configuration = this.$store.getters.resources.configuration;

    if (configuration.storage.update) {
      this.savingEnable = true;
    }

    this.init();
  },
  methods: {
    init() {
      // Add defaults to timezone and locale.
      this.tzList = this.$tzList.slice();
      this.tzList.unshift(i18n.t("Default"));

      this.localeList = [];

      for (let i = 0; i < this.$localeList.length; i++) {
        this.localeList.push({
          text: i18n.t(this.$localeList[i].text),
          value: this.$localeList[i].value,
        });
      }

      this.localeList.unshift({ text: i18n.t("Default"), value: "Default" });

      this.loadData();
    },
    sendError(error) {
      if (error.response) {
        if (
          error.response.status == 500 &&
          error.response.data.status == "error"
        ) {
          EventBus.$emit("SHOW_ERROR", error.response.data.error);
        } else {
          EventBus.$emit("SHOW_ERROR", error.response.data);
        }
      } else {
        EventBus.$emit("SHOW_ERROR", error);
      }
    },
    loadData() {
      axios({
        url: "/api/v1/config/dicomWeb",
        method: "GET",
      })
        .then((response) => {
          this.sopCuidsFilter = Sops.get_name(response.data.dicomWeb.sopCuidsFilter);

          let dicomViewers = response.data.dicomWeb.dicomViewers;
          this.orthancUrl = dicomViewers.orthancUrl;
          this.radiant = dicomViewers.radiantActive;
          this.weasis = dicomViewers.weasisActive;
          this.orthanc = dicomViewers.orthancActive;
          this.ohif = dicomViewers.ohifActive;
          this.horos = dicomViewers.horosActive;
          
          // stop loadings
          this.reloadLoading = false;
          this.firstLoading = false;
          this.saveDisabled = true;
        })
        .catch((error) => {
          this.reloadLoading = false;
          this.firstLoading = false;
          this.sendError(error);
        });
    },
    reload() {
      this.reloadLoading = true;
      this.loadData();
    },
    save() {
      this.saveLoading = true;

      // send configuration
      axios({
        url: "/api/v1/config/dicomWeb",
        method: "PUT",
        data: {
          sopCuidsFilter: Sops.get_uid(this.sopCuidsFilter),
          dicomViewers: {
            orthancUrl: this.orthancUrl,
            radiantActive: this.radiant,
            weasisActive: this.weasis,
            orthancActive: this.orthanc,
            ohifActive: this.ohif,
            horosActive: this.horos,
          }
        },
      })
        .then((response) => {
          this.saveLoading = false;
          if (
            !response.data ||
            !response.data.status ||
            !(response.data.status == "done")
          ) {
            this.sendError(response.data.error);
          } else {
            this.saveDisabled = true;
          }
        })
        .catch((error) => {
          this.saveLoading = false;
          this.sendError(error);
        });
    }
  },
};
</script>

<style scoped>
.disable-events {
  pointer-events: none;
}
.disabled { 
  filter: grayscale(80%) opacity(50%); 
}
</style>